import { Box, useColorModeValue } from '@chakra-ui/react';
import * as React from 'react';

const Card = (props) => (
  <Box
    overflow='hidden'
    mt='0px !important'
    bg={useColorModeValue('white', 'gray.700')}
    border='1px'
    borderColor='gray.200'
    borderRadius='0.625rem 0.625rem 0 0'
    {...props}
  />
);

export default Card;
